
import i18next from '../i18n'
import {CountryRepositoryType} from "../domain/interfaces/repositories/CountryRepositoryType.ts";
import Country from "../domain/entities/Country.ts";

export class CountryRepository implements CountryRepositoryType {
  loadAll(): Country[] {
    return this.countries
  }

  loadCountries(countriesIDs: string[]): Country[] {
    const countries: Country[] = []

    for (const countryID of countriesIDs) {
      const country = this.loadCountry(countryID)
      if (country) {
        countries.push(country)
      }
    }

    return countries
  }

  loadCountry(countryID: string): Country | undefined {
    return this.countries.find((country) => country.id === countryID)
  }

  loadExcludedShippingCountriesIDs(): Country['id'][] {
    return this.excludedShippingCountriesIDs
  }

  private get countries(): Country[] {
    return [
      new Country(
        '024',
        i18next.t('countries:countries.angola'),
        i18next.t('regions:regions.africa'),
        'ao'
      ),
      new Country(
        '012',
        i18next.t('countries:countries.algeria'),
        i18next.t('regions:regions.africa'),
        'dz'
      ),
      new Country(
        '204',
        i18next.t('countries:countries.benin'),
        i18next.t('regions:regions.africa'),
        'bj'
      ),
      new Country(
        '072',
        i18next.t('countries:countries.botswana'),
        i18next.t('regions:regions.africa'),
        'bw'
      ),
      new Country(
        '854',
        i18next.t('countries:countries.burkinaFaso'),
        i18next.t('regions:regions.africa'),
        'bf'
      ),
      new Country(
        '108',
        i18next.t('countries:countries.burundi'),
        i18next.t('regions:regions.africa'),
        'bi'
      ),
      new Country(
        '132',
        i18next.t('countries:countries.capeVerde'),
        i18next.t('regions:regions.africa'),
        'cv'
      ),
      new Country(
        '120',
        i18next.t('countries:countries.cameroon'),
        i18next.t('regions:regions.africa'),
        'cm'
      ),
      new Country(
        '148',
        i18next.t('countries:countries.chad'),
        i18next.t('regions:regions.africa'),
        'td'
      ),
      new Country(
        '724-18',
        i18next.t('countries:countries.ceuta'),
        i18next.t('regions:regions.africa'),
        'es-ce'
      ),
      new Country(
        '724-19',
        i18next.t('countries:countries.melilla'),
        i18next.t('regions:regions.africa'),
        'es-ml'
      ),
      new Country(
        '174',
        i18next.t('countries:countries.comoros'),
        i18next.t('regions:regions.africa'),
        'km'
      ),
      new Country(
        '384',
        i18next.t('countries:countries.ivoryCoast'),
        i18next.t('regions:regions.africa'),
        'ci'
      ),
      new Country(
        '818',
        i18next.t('countries:countries.egypt'),
        i18next.t('regions:regions.africa'),
        'eg'
      ),
      new Country(
        '232',
        i18next.t('countries:countries.eritrea'),
        i18next.t('regions:regions.africa'),
        'er'
      ),
      new Country(
        '748',
        i18next.t('countries:countries.swaziland'),
        i18next.t('regions:regions.africa'),
        'sz'
      ),
      new Country(
        '231',
        i18next.t('countries:countries.ethiopia'),
        i18next.t('regions:regions.africa'),
        'et'
      ),
      new Country(
        '266',
        i18next.t('countries:countries.gabon'),
        i18next.t('regions:regions.africa'),
        'ga'
      ),
      new Country(
        '270',
        i18next.t('countries:countries.gambia'),
        i18next.t('regions:regions.africa'),
        'gm'
      ),
      new Country(
        '288',
        i18next.t('countries:countries.ghana'),
        i18next.t('regions:regions.africa'),
        'gh'
      ),
      new Country(
        '324',
        i18next.t('countries:countries.guinea'),
        i18next.t('regions:regions.africa'),
        'gn'
      ),
      new Country(
        '624',
        i18next.t('countries:countries.guineaBissau'),
        i18next.t('regions:regions.africa'),
        'gw'
      ),
      new Country(
        '226',
        i18next.t('countries:countries.equatorialGuinea'),
        i18next.t('regions:regions.africa'),
        'gq'
      ),
      new Country(
        '404',
        i18next.t('countries:countries.kenya'),
        i18next.t('regions:regions.africa'),
        'ke'
      ),
      new Country(
        '426',
        i18next.t('countries:countries.lesotho'),
        i18next.t('regions:regions.africa'),
        'ls'
      ),
      new Country(
        '430',
        i18next.t('countries:countries.liberia'),
        i18next.t('regions:regions.africa'),
        'lr'
      ),
      new Country(
        '434',
        i18next.t('countries:countries.libya'),
        i18next.t('regions:regions.africa'),
        'ly'
      ),
      new Country(
        '450',
        i18next.t('countries:countries.madagascar'),
        i18next.t('regions:regions.africa'),
        'mg'
      ),
      new Country(
        '454',
        i18next.t('countries:countries.malawi'),
        i18next.t('regions:regions.africa'),
        'mw'
      ),
      new Country(
        '466',
        i18next.t('countries:countries.mali'),
        i18next.t('regions:regions.africa'),
        'ml'
      ),
      new Country(
        '504',
        i18next.t('countries:countries.morocco'),
        i18next.t('regions:regions.africa'),
        'ma'
      ),
      new Country(
        '478',
        i18next.t('countries:countries.mauritania'),
        i18next.t('regions:regions.africa'),
        'mr'
      ),
      new Country(
        '480',
        i18next.t('countries:countries.mauritius'),
        i18next.t('regions:regions.africa'),
        'mu'
      ),
      new Country(
        '508',
        i18next.t('countries:countries.mozambique'),
        i18next.t('regions:regions.africa'),
        'mz'
      ),
      new Country(
        '516',
        i18next.t('countries:countries.namibia'),
        i18next.t('regions:regions.africa'),
        'na'
      ),
      new Country(
        '566',
        i18next.t('countries:countries.nigeria'),
        i18next.t('regions:regions.africa'),
        'ng'
      ),
      new Country(
        '562',
        i18next.t('countries:countries.niger'),
        i18next.t('regions:regions.africa'),
        'ne'
      ),
      new Country(
        '140',
        i18next.t('countries:countries.centralAfricanRepublic'),
        i18next.t('regions:regions.africa'),
        'cf'
      ),
      new Country(
        '178',
        i18next.t('countries:countries.republicCongo'),
        i18next.t('regions:regions.africa'),
        'cg'
      ),
      new Country(
        '180',
        i18next.t('countries:countries.democraticRepublicCongo'),
        i18next.t('regions:regions.africa'),
        'cd'
      ),
      new Country(
        '646',
        i18next.t('countries:countries.rwanda'),
        i18next.t('regions:regions.africa'),
        'rw'
      ),
      new Country(
        '732',
        i18next.t('countries:countries.saharaOccidental'),
        i18next.t('regions:regions.africa'),
        'eh'
      ),
      new Country(
        '678',
        i18next.t('countries:countries.saoTomePrincipe'),
        i18next.t('regions:regions.africa'),
        'st'
      ),
      new Country(
        '686',
        i18next.t('countries:countries.senegal'),
        i18next.t('regions:regions.africa'),
        'sn'
      ),
      new Country(
        '690',
        i18next.t('countries:countries.seychelles'),
        i18next.t('regions:regions.africa'),
        'sc'
      ),
      new Country(
        '694',
        i18next.t('countries:countries.sierraLeone'),
        i18next.t('regions:regions.africa'),
        'sl'
      ),
      new Country(
        '706',
        i18next.t('countries:countries.somalia'),
        i18next.t('regions:regions.africa'),
        'so'
      ),
      new Country(
        '710',
        i18next.t('countries:countries.southAfrica'),
        i18next.t('regions:regions.africa'),
        'za'
      ),
      new Country(
        '729',
        i18next.t('countries:countries.sudan'),
        i18next.t('regions:regions.africa'),
        'sd'
      ),
      new Country(
        '728',
        i18next.t('countries:countries.southSudan'),
        i18next.t('regions:regions.africa'),
        'ss'
      ),
      new Country(
        '834',
        i18next.t('countries:countries.tanzania'),
        i18next.t('regions:regions.africa'),
        'tz'
      ),
      new Country(
        '768',
        i18next.t('countries:countries.togo'),
        i18next.t('regions:regions.africa'),
        'tg'
      ),
      new Country(
        '788',
        i18next.t('countries:countries.tunisia'),
        i18next.t('regions:regions.africa'),
        'tn'
      ),
      new Country(
        '800',
        i18next.t('countries:countries.uganda'),
        i18next.t('regions:regions.africa'),
        'ug'
      ),
      new Country(
        '262',
        i18next.t('countries:countries.djibouti'),
        i18next.t('regions:regions.africa'),
        'dj'
      ),
      new Country(
        '894',
        i18next.t('countries:countries.zambia'),
        i18next.t('regions:regions.africa'),
        'zm'
      ),
      new Country(
        '716',
        i18next.t('countries:countries.zimbabwe'),
        i18next.t('regions:regions.africa'),
        'zw'
      ),
      new Country(
        '028',
        i18next.t('countries:countries.antiguaBarbuda'),
        i18next.t('regions:regions.america'),
        'ag'
      ),
      new Country(
        '032',
        i18next.t('countries:countries.argentina'),
        i18next.t('regions:regions.america'),
        'ar'
      ),
      new Country(
        '044',
        i18next.t('countries:countries.bahamas'),
        i18next.t('regions:regions.america'),
        'bs'
      ),
      new Country(
        '052',
        i18next.t('countries:countries.barbados'),
        i18next.t('regions:regions.america'),
        'bb'
      ),
      new Country(
        '084',
        i18next.t('countries:countries.belize'),
        i18next.t('regions:regions.america'),
        'bz'
      ),
      new Country(
        '060',
        i18next.t('countries:countries.bermudas'),
        i18next.t('regions:regions.america'),
        'bm'
      ),
      new Country(
        '068',
        i18next.t('countries:countries.bolivia'),
        i18next.t('regions:regions.america'),
        'bo'
      ),
      new Country(
        '535',
        i18next.t('countries:countries.bonaire'),
        i18next.t('regions:regions.america'),
        'bq'
      ),
      new Country(
        '076',
        i18next.t('countries:countries.brazil'),
        i18next.t('regions:regions.america'),
        'br'
      ),
      new Country(
        '124',
        i18next.t('countries:countries.canada'),
        i18next.t('regions:regions.america'),
        'ca'
      ),
      new Country(
        '152',
        i18next.t('countries:countries.chile'),
        i18next.t('regions:regions.america'),
        'cl'
      ),
      new Country(
        '170',
        i18next.t('countries:countries.colombia'),
        i18next.t('regions:regions.america'),
        'co'
      ),
      new Country(
        '188',
        i18next.t('countries:countries.costaRica'),
        i18next.t('regions:regions.america'),
        'cr'
      ),
      new Country(
        '192',
        i18next.t('countries:countries.cuba'),
        i18next.t('regions:regions.america'),
        'cu'
      ),
      new Country(
        '212',
        i18next.t('countries:countries.dominique'),
        i18next.t('regions:regions.america'),
        'dm'
      ),
      new Country(
        '218',
        i18next.t('countries:countries.ecuador'),
        i18next.t('regions:regions.america'),
        'ec'
      ),
      new Country(
        '222',
        i18next.t('countries:countries.elSalvador'),
        i18next.t('regions:regions.america'),
        'sv'
      ),
      new Country(
        '840',
        i18next.t('countries:countries.usa'),
        i18next.t('regions:regions.america'),
        'us'
      ),
      new Country(
        '308',
        i18next.t('countries:countries.grenada'),
        i18next.t('regions:regions.america'),
        'gd'
      ),
      new Country(
        '304',
        i18next.t('countries:countries.groenlandia'),
        i18next.t('regions:regions.america'),
        'gl'
      ),
      new Country(
        '320',
        i18next.t('countries:countries.guatemala'),
        i18next.t('regions:regions.america'),
        'gt'
      ),
      new Country(
        '254',
        i18next.t('countries:countries.guyana'),
        i18next.t('regions:regions.america'),
        'gy'
      ),
      new Country(
        '332',
        i18next.t('countries:countries.haiti'),
        i18next.t('regions:regions.america'),
        'ht'
      ),
      new Country(
        '340',
        i18next.t('countries:countries.honduras'),
        i18next.t('regions:regions.america'),
        'hn'
      ),
      new Country(
        '388',
        i18next.t('countries:countries.jamaica'),
        i18next.t('regions:regions.america'),
        'jm'
      ),
      new Country(
        '484',
        i18next.t('countries:countries.mexico'),
        i18next.t('regions:regions.america'),
        'mx'
      ),
      new Country(
        '558',
        i18next.t('countries:countries.nicaragua'),
        i18next.t('regions:regions.america'),
        'ni'
      ),
      new Country(
        '591',
        i18next.t('countries:countries.panama'),
        i18next.t('regions:regions.america'),
        'pa'
      ),
      new Country(
        '600',
        i18next.t('countries:countries.paraguay'),
        i18next.t('regions:regions.america'),
        'py'
      ),
      new Country(
        '604',
        i18next.t('countries:countries.peru'),
        i18next.t('regions:regions.america'),
        'pe'
      ),
      new Country(
        '630',
        i18next.t('countries:countries.puertoRico'),
        i18next.t('regions:regions.america'),
        'pr'
      ),
      new Country(
        '214',
        i18next.t('countries:countries.dominicanRepublic'),
        i18next.t('regions:regions.america'),
        'do'
      ),
      new Country(
        '662',
        i18next.t('countries:countries.saintLucia'),
        i18next.t('regions:regions.america'),
        'lc'
      ),
      new Country(
        '659',
        i18next.t('countries:countries.saintKittsNeviss'),
        i18next.t('regions:regions.america'),
        'kn'
      ),
      new Country(
        '670',
        i18next.t('countries:countries.saintVincentGrenadines'),
        i18next.t('regions:regions.america'),
        'vc'
      ),
      new Country(
        '740',
        i18next.t('countries:countries.surinam'),
        i18next.t('regions:regions.america'),
        'sr'
      ),
      new Country(
        '780',
        i18next.t('countries:countries.trinidadTobago'),
        i18next.t('regions:regions.america'),
        'tt'
      ),
      new Country(
        '858',
        i18next.t('countries:countries.uruguay'),
        i18next.t('regions:regions.america'),
        'uy'
      ),
      new Country(
        '862',
        i18next.t('countries:countries.venezuela'),
        i18next.t('regions:regions.america'),
        've'
      ),
      new Country(
        '010',
        i18next.t('countries:countries.antartida'),
        i18next.t('regions:regions.antartica'),
        'aq'
      ),
      new Country(
        '004',
        i18next.t('countries:countries.afghanistan'),
        i18next.t('regions:regions.asia'),
        'af'
      ),
      new Country(
        '682',
        i18next.t('countries:countries.saudiArabia'),
        i18next.t('regions:regions.asia'),
        'sa'
      ),
      new Country(
        '051',
        i18next.t('countries:countries.armenia'),
        i18next.t('regions:regions.asia'),
        'am'
      ),
      new Country(
        '050',
        i18next.t('countries:countries.bangladesh'),
        i18next.t('regions:regions.asia'),
        'bd'
      ),
      new Country(
        '048',
        i18next.t('countries:countries.bahrain'),
        i18next.t('regions:regions.asia'),
        'bh'
      ),
      new Country(
        '096',
        i18next.t('countries:countries.brunei'),
        i18next.t('regions:regions.asia'),
        'bn'
      ),
      new Country(
        '064',
        i18next.t('countries:countries.bhutan'),
        i18next.t('regions:regions.asia'),
        'bt'
      ),
      new Country(
        '116',
        i18next.t('countries:countries.camboya'),
        i18next.t('regions:regions.asia'),
        'kh'
      ),
      new Country(
        '634',
        i18next.t('countries:countries.qatar'),
        i18next.t('regions:regions.asia'),
        'qa'
      ),
      new Country(
        '156',
        i18next.t('countries:countries.china'),
        i18next.t('regions:regions.asia'),
        'cn'
      ),
      new Country(
        '408',
        i18next.t('countries:countries.northKorea'),
        i18next.t('regions:regions.asia'),
        'kp'
      ),
      new Country(
        '410',
        i18next.t('countries:countries.southKorea'),
        i18next.t('regions:regions.asia'),
        'kr'
      ),
      new Country(
        '784',
        i18next.t('countries:countries.uae'),
        i18next.t('regions:regions.asia'),
        'ae'
      ),
      new Country(
        '608',
        i18next.t('countries:countries.phillipines'),
        i18next.t('regions:regions.asia'),
        'ph'
      ),
      new Country(
        '344',
        i18next.t('countries:countries.hongKong'),
        i18next.t('regions:regions.asia'),
        'hk'
      ),
      new Country(
        '356',
        i18next.t('countries:countries.india'),
        i18next.t('regions:regions.asia'),
        'in'
      ),
      new Country(
        '360',
        i18next.t('countries:countries.indonesia'),
        i18next.t('regions:regions.asia'),
        'id'
      ),
      new Country(
        '368',
        i18next.t('countries:countries.iraq'),
        i18next.t('regions:regions.asia'),
        'iq'
      ),
      new Country(
        '364',
        i18next.t('countries:countries.iran'),
        i18next.t('regions:regions.asia'),
        'ir'
      ),
      new Country(
        '376',
        i18next.t('countries:countries.israel'),
        i18next.t('regions:regions.asia'),
        'il'
      ),
      new Country(
        '392',
        i18next.t('countries:countries.japan'),
        i18next.t('regions:regions.asia'),
        'jp'
      ),
      new Country(
        '400',
        i18next.t('countries:countries.jordan'),
        i18next.t('regions:regions.asia'),
        'jo'
      ),
      new Country(
        '398',
        i18next.t('countries:countries.kazakhstan'),
        i18next.t('regions:regions.asia'),
        'kz'
      ),
      new Country(
        '417',
        i18next.t('countries:countries.kirgyzstan'),
        i18next.t('regions:regions.asia'),
        'kg'
      ),
      new Country(
        '639',
        i18next.t('countries:countries.kurdistan'),
        i18next.t('regions:regions.asia'),
        'kd'
      ),
      new Country(
        '414',
        i18next.t('countries:countries.kuwait'),
        i18next.t('regions:regions.asia'),
        'kw'
      ),
      new Country(
        '418',
        i18next.t('countries:countries.laos'),
        i18next.t('regions:regions.asia'),
        'la'
      ),
      new Country(
        '422',
        i18next.t('countries:countries.lebanon'),
        i18next.t('regions:regions.asia'),
        'lb'
      ),
      new Country(
        '446',
        i18next.t('countries:countries.macao'),
        i18next.t('regions:regions.asia'),
        'mo'
      ),
      new Country(
        '458',
        i18next.t('countries:countries.malaysia'),
        i18next.t('regions:regions.asia'),
        'my'
      ),
      new Country(
        '462',
        i18next.t('countries:countries.maldives'),
        i18next.t('regions:regions.asia'),
        'mv'
      ),
      new Country(
        '496',
        i18next.t('countries:countries.mongolia'),
        i18next.t('regions:regions.asia'),
        'mn'
      ),
      new Country(
        '104',
        i18next.t('countries:countries.myanmar'),
        i18next.t('regions:regions.asia'),
        'mm'
      ),
      new Country(
        '524',
        i18next.t('countries:countries.nepal'),
        i18next.t('regions:regions.asia'),
        'np'
      ),
      new Country(
        '512',
        i18next.t('countries:countries.oman'),
        i18next.t('regions:regions.asia'),
        'om'
      ),
      new Country(
        '586',
        i18next.t('countries:countries.pakistan'),
        i18next.t('regions:regions.asia'),
        'pk'
      ),
      new Country(
        '275',
        i18next.t('countries:countries.palestina'),
        i18next.t('regions:regions.asia'),
        'ps'
      ),
      new Country(
        '702',
        i18next.t('countries:countries.singapore'),
        i18next.t('regions:regions.asia'),
        'sg'
      ),
      new Country(
        '760',
        i18next.t('countries:countries.syria'),
        i18next.t('regions:regions.asia'),
        'sy'
      ),
      new Country(
        '144',
        i18next.t('countries:countries.sriLanka'),
        i18next.t('regions:regions.asia'),
        'lk'
      ),
      new Country(
        '764',
        i18next.t('countries:countries.thailand'),
        i18next.t('regions:regions.asia'),
        'th'
      ),
      new Country(
        '158',
        i18next.t('countries:countries.taiwan'),
        i18next.t('regions:regions.asia'),
        'tw'
      ),
      new Country(
        '762',
        i18next.t('countries:countries.tajikistan'),
        i18next.t('regions:regions.asia'),
        'tj'
      ),
      new Country(
        '626',
        i18next.t('countries:countries.eastTimor'),
        i18next.t('regions:regions.asia'),
        'tl'
      ),
      new Country(
        '795',
        i18next.t('countries:countries.turkmeinetan'),
        i18next.t('regions:regions.asia'),
        'tm'
      ),
      new Country(
        '860',
        i18next.t('countries:countries.uzbekistan'),
        i18next.t('regions:regions.asia'),
        'uz'
      ),
      new Country(
        '704',
        i18next.t('countries:countries.vietnam'),
        i18next.t('regions:regions.asia'),
        'vn'
      ),
      new Country(
        '887',
        i18next.t('countries:countries.yemen'),
        i18next.t('regions:regions.asia'),
        'ye'
      ),
      new Country(
        '031',
        i18next.t('countries:countries.azerbaijan'),
        i18next.t('regions:regions.europe'),
        'az'
      ),
      new Country(
        '268',
        i18next.t('countries:countries.georgia'),
        i18next.t('regions:regions.europe'),
        'ge'
      ),
      new Country(
        '643',
        i18next.t('countries:countries.russia'),
        i18next.t('regions:regions.europe'),
        'ru'
      ),
      new Country(
        '792',
        i18next.t('countries:countries.turkey'),
        i18next.t('regions:regions.europe'),
        'tr'
      ),
      new Country(
        '008',
        i18next.t('countries:countries.albania'),
        i18next.t('regions:regions.europe'),
        'al'
      ),
      new Country(
        '276',
        i18next.t('countries:countries.germany'),
        i18next.t('regions:regions.europe'),
        'de'
      ),
      new Country(
        '724-01',
        i18next.t('countries:countries.andalucia'),
        i18next.t('regions:regions.europe'),
        'es-an'
      ),
      new Country(
        '020',
        i18next.t('countries:countries.andorra'),
        i18next.t('regions:regions.europe'),
        'ad'
      ),
      new Country(
        '724-02',
        i18next.t('countries:countries.aragon'),
        i18next.t('regions:regions.europe'),
        'es-ar'
      ),
      new Country(
        '040',
        i18next.t('countries:countries.austria'),
        i18next.t('regions:regions.europe'),
        'at'
      ),
      new Country(
        '056',
        i18next.t('countries:countries.belgium'),
        i18next.t('regions:regions.europe'),
        'be'
      ),
      new Country(
        '112',
        i18next.t('countries:countries.belarus'),
        i18next.t('regions:regions.europe'),
        'by'
      ),
      new Country(
        '070',
        i18next.t('countries:countries.bosniaHerzegovina'),
        i18next.t('regions:regions.europe'),
        'ba'
      ),
      new Country(
        '100',
        i18next.t('countries:countries.bulgaria'),
        i18next.t('regions:regions.europe'),
        'bg'
      ),
      new Country(
        '724-05',
        i18next.t('countries:countries.canarias'),
        i18next.t('regions:regions.europe'),
        'es-cn'
      ),
      new Country(
        '724-06',
        i18next.t('countries:countries.cantabria'),
        i18next.t('regions:regions.europe'),
        'es-cb'
      ),
      new Country(
        '724-07',
        i18next.t('countries:countries.castillaLeon'),
        i18next.t('regions:regions.europe'),
        'es-cl'
      ),
      new Country(
        '724-08',
        i18next.t('countries:countries.castillaMancha'),
        i18next.t('regions:regions.europe'),
        'es-cm'
      ),
      new Country(
        '724-09',
        i18next.t('countries:countries.cataluña'),
        i18next.t('regions:regions.europe'),
        'es-ct'
      ),
      new Country(
        '196',
        i18next.t('countries:countries.cyprus'),
        i18next.t('regions:regions.europe'),
        'cy'
      ),
      new Country(
        '336',
        i18next.t('countries:countries.vaticanCity'),
        i18next.t('regions:regions.europe'),
        'va'
      ),
      new Country(
        '724-13',
        i18next.t('countries:countries.comunidadMadrid'),
        i18next.t('regions:regions.europe'),
        'es-md'
      ),
      new Country(
        '724-15',
        i18next.t('countries:countries.navarra'),
        i18next.t('regions:regions.europe'),
        'es-nc'
      ),
      new Country(
        '724-10',
        i18next.t('countries:countries.comunidadValenciana'),
        i18next.t('regions:regions.europe'),
        'es-vc'
      ),
      new Country(
        '191',
        i18next.t('countries:countries.croatia'),
        i18next.t('regions:regions.europe'),
        'hr'
      ),
      new Country(
        '208',
        i18next.t('countries:countries.denmark'),
        i18next.t('regions:regions.europe'),
        'dk'
      ),
      new Country(
        '826-02',
        i18next.t('countries:countries.escocia'),
        i18next.t('regions:regions.europe'),
        'uk-sc'
      ),
      new Country(
        '703',
        i18next.t('countries:countries.slovakRepublic'),
        i18next.t('regions:regions.europe'),
        'sk'
      ),
      new Country(
        '705',
        i18next.t('countries:countries.slovenia'),
        i18next.t('regions:regions.europe'),
        'si'
      ),
      new Country(
        '724',
        i18next.t('countries:countries.spain'),
        i18next.t('regions:regions.europe'),
        'es'
      ),
      new Country(
        '233',
        i18next.t('countries:countries.estonia'),
        i18next.t('regions:regions.europe'),
        'ee'
      ),
      new Country(
        '724-11',
        i18next.t('countries:countries.extremadura'),
        i18next.t('regions:regions.europe'),
        'es-ex'
      ),
      new Country(
        '246',
        i18next.t('countries:countries.finland'),
        i18next.t('regions:regions.europe'),
        'fi'
      ),
      new Country(
        '250',
        i18next.t('countries:countries.france'),
        i18next.t('regions:regions.europe'),
        'fr'
      ),
      new Country(
        '826-01',
        i18next.t('countries:countries.gales'),
        i18next.t('regions:regions.europe'),
        'uk-wl'
      ),
      new Country(
        '724-12',
        i18next.t('countries:countries.galicia'),
        i18next.t('regions:regions.europe'),
        'es-ga'
      ),
      new Country(
        '300',
        i18next.t('countries:countries.greece'),
        i18next.t('regions:regions.europe'),
        'gr'
      ),
      new Country(
        '348',
        i18next.t('countries:countries.hungary'),
        i18next.t('regions:regions.europe'),
        'hu'
      ),
      new Country(
        '826-03',
        i18next.t('countries:countries.inglaterra'),
        i18next.t('regions:regions.europe'),
        'uk-en'
      ),
      new Country(
        '372',
        i18next.t('countries:countries.ireland'),
        i18next.t('regions:regions.europe'),
        'ie'
      ),
      new Country(
        '826-04',
        i18next.t('countries:countries.irlandaNorte'),
        i18next.t('regions:regions.europe'),
        'uk-ni'
      ),
      new Country(
        '352',
        i18next.t('countries:countries.iceland'),
        i18next.t('regions:regions.europe'),
        'is'
      ),
      new Country(
        '724-04',
        i18next.t('countries:countries.islasBaleares'),
        i18next.t('regions:regions.europe'),
        'es-ib'
      ),
      new Country(
        '234',
        i18next.t('countries:countries.islasFeroe'),
        i18next.t('regions:regions.europe'),
        'fo'
      ),
      new Country(
        '380',
        i18next.t('countries:countries.italy'),
        i18next.t('regions:regions.europe'),
        'it'
      ),
      new Country(
        '381',
        i18next.t('countries:countries.kosovo'),
        i18next.t('regions:regions.europe'),
        'ks'
      ),
      new Country(
        '724-17',
        i18next.t('countries:countries.laRioja'),
        i18next.t('regions:regions.europe'),
        'es-ri'
      ),
      new Country(
        '428',
        i18next.t('countries:countries.latvia'),
        i18next.t('regions:regions.europe'),
        'lv'
      ),
      new Country(
        '438',
        i18next.t('countries:countries.liechtenstein'),
        i18next.t('regions:regions.europe'),
        'li'
      ),
      new Country(
        '440',
        i18next.t('countries:countries.lithuania'),
        i18next.t('regions:regions.europe'),
        'lt'
      ),
      new Country(
        '442',
        i18next.t('countries:countries.luxembourg'),
        i18next.t('regions:regions.europe'),
        'lu'
      ),
      new Country(
        '807',
        i18next.t('countries:countries.macedonia'),
        i18next.t('regions:regions.europe'),
        'mk'
      ),
      new Country(
        '470',
        i18next.t('countries:countries.malta'),
        i18next.t('regions:regions.europe'),
        'mt'
      ),
      new Country(
        '498',
        i18next.t('countries:countries.moldova'),
        i18next.t('regions:regions.europe'),
        'md'
      ),
      new Country(
        '492',
        i18next.t('countries:countries.monaco'),
        i18next.t('regions:regions.europe'),
        'mc'
      ),
      new Country(
        '499',
        i18next.t('countries:countries.montenegro'),
        i18next.t('regions:regions.europe'),
        'me'
      ),
      new Country(
        '578',
        i18next.t('countries:countries.norway'),
        i18next.t('regions:regions.europe'),
        'no'
      ),
      new Country(
        '724-16',
        i18next.t('countries:countries.paisVasco'),
        i18next.t('regions:regions.europe'),
        'es-pv'
      ),
      new Country(
        '528',
        i18next.t('countries:countries.netherlands'),
        i18next.t('regions:regions.europe'),
        'nl'
      ),
      new Country(
        '616',
        i18next.t('countries:countries.poland'),
        i18next.t('regions:regions.europe'),
        'pl'
      ),
      new Country(
        '620',
        i18next.t('countries:countries.portugal'),
        i18next.t('regions:regions.europe'),
        'pt'
      ),
      new Country(
        '724-03',
        i18next.t('countries:countries.principadoAsturias'),
        i18next.t('regions:regions.europe'),
        'es-as'
      ),
      new Country(
        '724-14',
        i18next.t('countries:countries.regionMurcia'),
        i18next.t('regions:regions.europe'),
        'es-mc'
      ),
      new Country(
        '826',
        i18next.t('countries:countries.unitedKingdom'),
        i18next.t('regions:regions.europe'),
        'uk'
      ),
      new Country(
        '203',
        i18next.t('countries:countries.czechRepublic'),
        i18next.t('regions:regions.europe'),
        'cz'
      ),
      new Country(
        '642',
        i18next.t('countries:countries.romania'),
        i18next.t('regions:regions.europe'),
        'ro'
      ),
      new Country(
        '674',
        i18next.t('countries:countries.sanMarino'),
        i18next.t('regions:regions.europe'),
        'sm'
      ),
      new Country(
        '688',
        i18next.t('countries:countries.serbia'),
        i18next.t('regions:regions.europe'),
        'rs'
      ),
      new Country(
        '752',
        i18next.t('countries:countries.sweden'),
        i18next.t('regions:regions.europe'),
        'se'
      ),
      new Country(
        '756',
        i18next.t('countries:countries.switzerland'),
        i18next.t('regions:regions.europe'),
        'ch'
      ),
      new Country(
        '804',
        i18next.t('countries:countries.ukraine'),
        i18next.t('regions:regions.europe'),
        'ua'
      ),
      new Country(
        '036',
        i18next.t('countries:countries.australia'),
        i18next.t('regions:regions.oceania'),
        'au'
      ),
      new Country(
        '242',
        i18next.t('countries:countries.fiji'),
        i18next.t('regions:regions.oceania'),
        'fj'
      ),
      new Country(
        '243',
        i18next.t('countries:countries.cookIslands'),
        i18next.t('regions:regions.oceania'),
        'ck'
      ),
      new Country(
        '584',
        i18next.t('countries:countries.marshallIslands'),
        i18next.t('regions:regions.oceania'),
        'mh'
      ),
      new Country(
        '090',
        i18next.t('countries:countries.solomonIslands'),
        i18next.t('regions:regions.oceania'),
        'sb'
      ),
      new Country(
        '296',
        i18next.t('countries:countries.kiribati'),
        i18next.t('regions:regions.oceania'),
        'ki'
      ),
      new Country(
        '583',
        i18next.t('countries:countries.micronesia'),
        i18next.t('regions:regions.oceania'),
        'fm'
      ),
      new Country(
        '520',
        i18next.t('countries:countries.nauru'),
        i18next.t('regions:regions.oceania'),
        'nr'
      ),
      new Country(
        '554',
        i18next.t('countries:countries.newZeland'),
        i18next.t('regions:regions.oceania'),
        'nz'
      ),
      new Country(
        '585',
        i18next.t('countries:countries.palau'),
        i18next.t('regions:regions.oceania'),
        'pw'
      ),
      new Country(
        '598',
        i18next.t('countries:countries.papuaNewGuinea'),
        i18next.t('regions:regions.oceania'),
        'pg'
      ),
      new Country(
        '258',
        i18next.t('countries:countries.polinesiaFrancesa'),
        i18next.t('regions:regions.oceania'),
        'pf'
      ),
      new Country(
        '882',
        i18next.t('countries:countries.samoa'),
        i18next.t('regions:regions.oceania'),
        'ws'
      ),
      new Country(
        '776',
        i18next.t('countries:countries.tonga'),
        i18next.t('regions:regions.oceania'),
        'to'
      ),
      new Country(
        '798',
        i18next.t('countries:countries.tuvalu'),
        i18next.t('regions:regions.oceania'),
        'tv'
      ),
      new Country(
        '548',
        i18next.t('countries:countries.vanuatu'),
        i18next.t('regions:regions.oceania'),
        'vu'
      )
    ]
  }

  private get excludedShippingCountriesIDs(): Country['id'][] {
    return [
      '639',
      '344',
      '158',
      '258',
      '275',
      '732',
      '826-01',
      '826-02',
      '826-03',
      '826-04',
      '234',
      '304',
      '010',
      '446',
      '724-01',
      '724-02',
      '724-03',
      '724-04',
      '724-05',
      '724-06',
      '724-07',
      '724-08',
      '724-09',
      '724-10',
      '724-11',
      '724-12',
      '724-13',
      '724-14',
      '724-15',
      '724-16',
      '724-17',
      '724-18',
      '724-19'
    ]
  }
}
